import React from "react";
import { formatContext } from "../../utils/assignments/formatContext";
import "../../styles/contextColumn.css";

const ContextColumn = ({ passage, context, imageUrl }) => {
  const content = passage || context || null;

  return (
    <div className="context-column">
      <div className="context-content">
        {content ? formatContext(content) : null}

        {imageUrl ? (
          <img
            src={imageUrl}
            alt="Question context"
            className="context-image"
          />
        ) : null}
      </div>
    </div>
  );
};

export default ContextColumn;
